<template>
  <div class="devotion">
    <!-- <div class="devotion-banner">
      <img src="../../picture/In-Meeting.jpg" />
    </div> -->
    <div class="devotion-content">
      <div class="devotion-content-title">
        <h2>{{$t('header[1].subMenu[1].title')}}</h2>
      </div>
      <div class="devotion-content-list">
        <router-link :to="`/devotion/${item}`"
                     v-for="item in magazineList"
                     :key="item"
                     class="devotion-content-list-li">
          <div class="img">
            <img v-lazy="`${url}/devotion/a/i${item}.jpg`"
                 :data-url="`${url}/devotion/a/i${item}.jpg`">
          </div>
          <div class="
                 title">{{$t('issue')}} {{item}}{{$t('stage')}}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Devotion',
  data () {
    return {
      url: this.$store.state.baseURL + '/',
      magazineList: [
      36, 35, 34, 33, 32, 31, 30, 
      29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 
      19, 18, 17, 16, 15, 14, 13, 12, 11, 10,
      '09', '08', '07', '06', '05', '04', '03', '02', '01']
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../static/stylebody.css";

.devotion {
  margin-top: 146px;
  margin-bottom: 130px;
  &-banner {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-height: 800px;
    img {
      width: 100%;
    }
  }
  &-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &-title {
      width: 100%;
    }
    &-list {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      &-li {
        margin-bottom: 30px;
        margin-right: 30px;
        width: calc(25% - 23.5px);
        text-align: center;
        cursor: pointer;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .img {
          width: 100%;
          border: 1px solid #eeeeee;
          img {
            width: 100%;
          }
        }
        .title {
          margin-top: 10px;
          margin-right: 0;
          font-size: 26px;
          color: #333;
        }
        &:hover {
          .img {
            box-shadow: 8px 8px 4px #ccc;
            -webkit-box-shadow: 8px 8px 4px #ccc;
          }
          .title {
            color: $color-2;
          }
        }
      }
    }
  }
}

@media (max-width: 1600px) {
  .devotion {
    margin-top: 136px;
    margin-bottom: 110px;
    &-content {
      &-list {
        &-li {
          .title {
            font-size: 24px;
          }
        }
      }
    }
  }
}

@media (max-width: 1440px) {
  .devotion {
    margin-top: 135px;
    margin-bottom: 100px;
    &-content {
      &-list {
        &-li {
          margin-bottom: 30px;
          margin-right: 25px;
          width: calc(25% - 19px);
          .title {
            margin-top: 8px;
            font-size: 25px;
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .devotion {
    margin-top: 120px;
    margin-bottom: 90px;
    &-content {
      &-list {
        &-li {
          margin-bottom: 30px;
          margin-right: 20px;
          width: calc(33.33% - 14.5px);
          &:nth-child(2n) {
            margin-right: 20px;
          }
          &:nth-child(3n) {
            margin-right: 0;
          }
          .title {
            margin-top: 8px;
            font-size: 23px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .devotion {
    margin-top: 50px;
    padding: 50px 16px 0;
    &-content {
      &-list {
        &-li {
          margin-bottom: 40px;
          margin-right: 20px;
          width: calc(50% - 10px);
          &:nth-child(2n) {
            margin-right: 0;
          }
          &:nth-child(3n) {
            margin-right: auto;
          }
          .title {
            margin-top: 8px;
            font-size: 20px;
          }
        }
      }
    }
  }
}

@media (max-width: 320px) {
  .devotion {
    &-content {
      &-business {
        &-list {
          &-box {
            padding-top: 100%;
            margin-right: 0;
            width: 100%;
            // &:nth-child(3n) {
            //   margin-right: 0;
            // }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/Devotion.vue